import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

// Primer pipe
@Pipe({
  name: 'updatePipe',
  standalone: true,
})
export class updatePipe implements PipeTransform {
  constructor(
    private translate: TranslateService,
    private sanitizer: DomSanitizer
  ) {}
  transform(value: string): any {
    let formattedString = value;
    const splitData = value.split('*@*');
    if (splitData.length > 3) {
      if (splitData[0] == "updated_by"){
        return null;
      }
      formattedString =
        this.translate.instant('inputs.' + splitData[0]) +
        this.translate.instant('pipe.update') +
        (splitData[1] === ''
          ? this.translate.instant('pipe.null')
          : splitData[1]) +
        this.translate.instant('pipe.to') +
        splitData.slice(2).join('-');
    }
    if (splitData.length == 3) {
      if (splitData[0] == "updated_by"){
        return null;
      }
      formattedString =
        this.translate.instant('inputs.' + splitData[0]) +
        this.translate.instant('pipe.update') +
        (splitData[1] === ''
          ? this.translate.instant('pipe.null')
          : splitData[1]) +
        this.translate.instant('pipe.to') +
        splitData[2];
    }
    /*  if (splitData.length > 3) {
      return this.translate.instant('pipe.data_label') + ": " + this.translate.instant( "inputs."+splitData[0])  +
      ", " + this.translate.instant('pipe.old_data_label') + ": " + splitData[1] +
      ", " + this.translate.instant('pipe.new_data_label') + ": " + splitData.slice(2).join('-');
  }
  if (splitData.length == 3) {
      return this.translate.instant('pipe.data_label') + ": " +this.translate.instant( "inputs."+splitData[0])  +
      ", " + this.translate.instant('pipe.old_data_label') + ": " + splitData[1] +
      ", " + this.translate.instant('pipe.new_data_label') + ": " + splitData[2] ;
  }  */

    return this.sanitizer.bypassSecurityTrustHtml(formattedString);
  }
}

// Primer pipe
@Pipe({
  name: 'updatePipe2',
  standalone: true,
})
export class updatePipe2 implements PipeTransform {
  constructor(
    private translate: TranslateService,
    private sanitizer: DomSanitizer
  ) {}
  transform(value: string): any {
    let formattedString = value;
    const splitData = value.split('*@*');
    if (splitData.length > 2) {
      formattedString =
        this.translate.instant('pipe.upload') +
        this.translate.instant('select.document_type.' + splitData[0]) +
        this.translate.instant('pipe.name') +
        (splitData[1] === ''
          ? this.translate.instant('pipe.null')
          : splitData.slice(1).join('-'));
    }
    if (splitData.length == 2) {
      formattedString =
        this.translate.instant('pipe.upload') +
        this.translate.instant('select.document_type.' + splitData[0]) +
        this.translate.instant('pipe.name') +
        (splitData[1] === ''
          ? this.translate.instant('pipe.null')
          : splitData[1]);
    }
    return this.sanitizer.bypassSecurityTrustHtml(formattedString);
  }
}

// Primer pipe
@Pipe({
  name: 'updatePipe3',
  standalone: true,
})
export class updatePipe3 implements PipeTransform {
  constructor(
    private translate: TranslateService,
    private sanitizer: DomSanitizer
  ) {}
  transform(value: string): any {
    let formattedString =this.translate.instant('pipe.stage') + this.translate.instant('badge-status_select-stage.' + value);
    return this.sanitizer.bypassSecurityTrustHtml(formattedString);
  }
}
@Pipe({
  name: 'updatePipe4',
  standalone: true,
})
export class updatePipe4 implements PipeTransform {
  constructor(
    private translate: TranslateService,
    private sanitizer: DomSanitizer
  ) {}
  transform(value: string): any {
    let formattedString =this.translate.instant('pipe.notes') + value;
    return this.sanitizer.bypassSecurityTrustHtml(formattedString);
  }
}
@Pipe({
  name: 'updatePipe4Private',
  standalone: true,
})
export class updatePipe4Private implements PipeTransform {
  constructor(
    private translate: TranslateService,
    private sanitizer: DomSanitizer
  ) {}
  transform(value: string): any {
    let formattedString =this.translate.instant('pipe.private_notes') + value;
    return this.sanitizer.bypassSecurityTrustHtml(formattedString);
  }
}

@Pipe({
  name: 'updatePipe5',
  standalone: true,
})
export class updatePipe5 implements PipeTransform {
  constructor(
    private translate: TranslateService,
    private sanitizer: DomSanitizer
  ) {}
  transform(value: string): any {
    let reference = value.split("/"); // ["uno", "dos", "tres", "cuatro"]
    let formattedString =  this.translate.instant('pipe.copied') +  "<a href='"+value+"' target='_blank' > "+ reference[reference.length - 1] +"</a>";
    return this.sanitizer.bypassSecurityTrustHtml(formattedString);
  }
}

// VIN event pipe
@Pipe({
  name: 'vinEventPipe',
  standalone: true,
})
export class vinEventPipe implements PipeTransform {
  private readonly VIN_MARKERS = new Set([
    'vin_added',
    'vin_updated',
    'vin_removed',
    'vins_imported',
  ]);

  constructor(
    private translate: TranslateService,
    private sanitizer: DomSanitizer
  ) {}

  transform(value: string): any {
    const splitData = value.split('*@*');
    const field = splitData[0];

    // Marker value (first item in values array) — show event label + VIN
    if (this.VIN_MARKERS.has(field)) {
      const vin = splitData[2] || splitData[1] || '';
      const label = this.translate.instant('timeline.' + field);
      if (vin) {
        return this.sanitizer.bypassSecurityTrustHtml(
          `<strong>${label}</strong>: <span class='pipe-second'>${vin}</span>`
        );
      }
      return this.sanitizer.bypassSecurityTrustHtml(`<strong>${label}</strong>`);
    }

    // Detail/metadata value — show field diff (old → new)
    const fieldLabel = this.translate.instant('inputs.' + field);
    const oldVal = this.translateStateValue(field, splitData[1] || '');
    const newVal = this.translateStateValue(field, splitData.length > 2 ? splitData.slice(2).join('-') : '');

    if (oldVal && newVal) {
      return this.sanitizer.bypassSecurityTrustHtml(
        fieldLabel +
        this.translate.instant('pipe.update') +
        oldVal +
        this.translate.instant('pipe.to') +
        newVal
      );
    }

    if (newVal) {
      return this.sanitizer.bypassSecurityTrustHtml(
        fieldLabel + ': ' + newVal
      );
    }

    if (oldVal) {
      return this.sanitizer.bypassSecurityTrustHtml(
        fieldLabel + ': ' + oldVal
      );
    }

    return this.sanitizer.bypassSecurityTrustHtml(fieldLabel);
  }

  private translateStateValue(field: string, val: string): string {
    if (!val) return '';
    if (field === 'state') {
      const translated = this.translate.instant('pipe.vin_states.' + val);
      return translated !== 'pipe.vin_states.' + val ? translated : val;
    }
    return val;
  }
}

// Segundo pipe
@Pipe({
  name: 'capitalize',
  standalone: true,
})
export class CapitalizePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }
}

@Pipe({
  name: 'filterSelectTypes',
  standalone: true,
})
export class FilterSelectTypesPipe implements PipeTransform {
  transform(selectTypes: any[], clientType: string): any[] {
     if (!selectTypes || !clientType) {
      return selectTypes;
    }
     return selectTypes.filter((t) => t.type === clientType);
  }
}
@Pipe({
  name: 'formatDatePipe',
  standalone: true,
})
export class FormatDatePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';

    // Asegurarse de que el formato sea válido antes de transformar
    const [year, month, day] = value.split('-');
    if (!year || !month || !day) return value;

    // Retornar en formato DD/MM/YYYY
    return `${day}/${month}/${year}`;
  }
}


@Pipe({
  name: 'formatNumberPipe2',
  standalone: true,
})
export class FormatNumberPipe2 implements PipeTransform {
  transform(value: string | number): string {
    if (value === null || value === undefined || value === '') return '';

    const num = typeof value === 'number' ? value : Number(value);
    if (!isNaN(num)) {
      const formatted = num
        .toFixed(2) // 2 decimales
        .replace('.', ',') // cambiar punto por coma

      const decimalPart = formatted.slice(formatted.indexOf(',')); // extraer desde la coma

      return `${decimalPart} €`;
    }

    return String(value);
  }
}

@Pipe({
  name: 'formatNumberPipe',
  standalone: true,
})
export class FormatNumberPipe implements PipeTransform {
  transform(value: string | number): string {
    if (value === null || value === undefined || value === '') return '';

    const num = typeof value === 'number' ? value : Number(value);
    if (!isNaN(num)) {
      // Obtener la parte entera
      const integerPart = Math.trunc(num);

      // Formatear la parte entera con punto como separador de miles
      return integerPart
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    return String(value);
  }
}
@Pipe({
  name: 'formatNumberPipe3',
  standalone: true,
})
export class FormatNumberPipe3 implements PipeTransform {
  transform(value: string | number): string {
    if (value === null || value === undefined || value === '') return '';

    const num = typeof value === 'number' ? value : Number(value);
    if (!isNaN(num)) {
      const formatted = num.toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // Punto para miles

      return `${formatted}`;       // Agrega símbolo del euro
    }

    return String(value);
  }
}

@Pipe({
  name: 'formatDateTimePipe',
  standalone: true,
})
export class FormatDateTimePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    // Separar la parte de la fecha y la hora
    const [datePart, timePart] = value.split(' ');
    if (!datePart) return value;

    // Separar año, mes y día
    const [year, month, day] = datePart.split('-');
    if (!year || !month || !day) return value;

    // Retornar en formato DD/MM/YYYY HH:mm:ss
    return `${day}/${month}/${year} ${timePart || ''}`;
  }
}


@Pipe({
  name: 'formatOptions',
  standalone: true
})
export class FormatOptionsPipe implements PipeTransform {
  transform(options: { name: string, amount: string }[]): string {
    if (!Array.isArray(options)) return '';
    return options
      .map(opt => `${opt.name} : ${opt.amount}`)
      .join('\n');
  }
}
